import { createFileRoute } from '@tanstack/react-router'

import Terms from 'pages/Terms/Terms'

// Public: outside the _auth layout, like /login (#3982).
export const Route = createFileRoute('/terms')({
  component: Terms,
})
